function StreamingIndicator() {
  return (
    <span className="ml-1" data-testid="streaming">
      <span
        className="inline-block w-3 h-3 rounded-full animate-spin"
        style={{
          background:
            "conic-gradient(from 180deg at 50% 50%, #3BCDAA 0deg, #26A4FF 360deg)",
        }}
      />
    </span>
  );
}

export default StreamingIndicator;
